<div class="row">
  <div class="col-12">
    <nav aria-label="breadcrumb" class="vm-breadcrumb mb-3 {{class}}" [style]="style">
      <ol class="breadcrumb ">
        <ng-container *ngFor="let object of datasource; let first = first; let last = last">
          <li class="breadcrumb-item">
            <ng-container *ngIf="last; else breadcrumbItemName">
              {{ object[nameKey] }}
            </ng-container>
            <ng-template #breadcrumbItemName>
                {{ isenable }}
                <a (click)="
                    getMappedBoolValue(object, isClickableKey)
                      ? itemClick(object)
                      : null
                  ">{{ object[nameKey] }}</a>
            </ng-template>
          </li>
          <li class="vm-breadcrumb__devider vm-icon" *ngIf="!last">
            <span class="material-symbols-outlined"> {{breadcrumbDivider}}</span>
          </li>
        </ng-container>
      </ol>
    </nav>
  </div>
</div>
